import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { DynamicIOProductTableDesktopLoading } from './desktop';
import { DynamicIOProductTableMobileLoading } from './mobile';
export interface DynamicIOProductTableLoadingProps {
  columnsCount?: number;
  rowsCount?: number;
  mobileDetailRowsCount?: number;
  showAction?: boolean;
}

export const DynamicIOProductTableLoading: React.FC<DynamicIOProductTableLoadingProps> = (
  props
) => {
  const dynamicIOProductTableLoading = useBreakpointValue({
    base: <DynamicIOProductTableMobileLoading {...props} />,
    lg: <DynamicIOProductTableDesktopLoading {...props} />,
  });

  return dynamicIOProductTableLoading;
};
